import Link from '@mui/material/Link';
import { ReactNode } from 'react';

// Allow-list, so no other scheme (`javascript:` included) can be made clickable.
const URL_PATTERN = /(?:https?:\/\/|www\.)\S+/gi;

const TRAILING_PUNCTUATION = /[.,;:!?)\]}'"]+$/;

const BARE_PREFIX = /^(?:https?:\/\/|www\.)$/i;

const resolveHref = (url: string) =>
  url.toLowerCase().startsWith('www.') ? `https://${url}` : url;

/** Content is user input, so it is rendered as React elements only, never as markup. */
export default function linkifyMessageContent(
  content: string,
  onLinkClick: (href: string) => void,
) {
  const nodes: ReactNode[] = [];
  let cursor = 0;

  for (const match of content.matchAll(URL_PATTERN)) {
    const url = match[0].replace(TRAILING_PUNCTUATION, '');
    if (match.index === undefined || BARE_PREFIX.test(url)) continue;

    if (match.index > cursor) {
      nodes.push(content.slice(cursor, match.index));
    }

    const href = resolveHref(url);

    nodes.push(
      <Link
        href={href}
        key={`${match.index}-${url}`}
        // A sender chose this destination, so the caller confirms it before we go there.
        onClick={(event) => {
          event.preventDefault();
          onLinkClick(href);
        }}
        rel="noopener noreferrer"
        // MUI's default `primary` is brand yellow, unreadable on a message bubble.
        sx={(theme) => ({ color: theme.semantic.linkText })}
        target="_blank"
      >
        {url}
      </Link>,
    );

    cursor = match.index + url.length;
  }

  if (cursor < content.length) {
    nodes.push(content.slice(cursor));
  }

  return nodes;
}
